{
  "de": {
    "issue": {
      "actions": {
        "approve_for_customer": "Für den Kunden genehmigen",
        "assign": "Zuweisen",
        "cancel_approval": "Kundengenehmigung zurückziehen",
        "collapse": "Punkte einklappen",
        "create_category": "Neue Kategorie hinzufügen",
        "create_issue": "Punkt erstellen",
        "create_issue_customer": "Punkt melden",
        "delete": "Punkt löschen",
        "expand": "Punkte ausklappen",
        "export_images": "Bilder herunterladen",
        "hideActivity": "Aktivität ausblenden",
        "openConversation": "Konversation öffnen",
        "reject_for_customer": "Für den Kunden ablehnen",
        "request_approval": "Kundengenehmigung anfordern",
        "show": "Punkt anzeigen",
        "showActivity": "Aktivität anzeigen",
        "startConversation": "Konversation starten",
        "start_conversation": "Konversation über diesen Punkt starten",
        "undo_customer_approval": "Kundengenehmigung rückgängig machen",
        "undo_customer_rejection": "Kundenablehnung rückgängig machen",
        "update": "Punkte aktualisieren"
      },
      "attributes": {
        "approval_status": "Kundengenehmigung",
        "assignee": "Zugewiesen an",
        "category": "Kategorie",
        "created_at": "Erstellt",
        "deadline": "Frist",
        "description": "Beschreibung",
        "issue_list_type": "Punkteliste",
        "name": "Name",
        "responsible": "Verantwortlich",
        "status": "Status",
        "statuses": {
          "approval_not_requested": "Nicht angefordert",
          "approval_requested": "Angefordert",
          "approved": "Genehmigt",
          "completed": "Abgeschlossen",
          "created": "Offen",
          "declined": "Abgelehnt",
          "inbox": "Gesendet",
          "not_completed": "Nicht abgeschlossen",
          "ongoing": "Laufend"
        },
        "updated_at": "Letzte Aktualisierung"
      },
      "edit_actions": {
        "edit_category": "Kategorie",
        "edit_deadline": "Frist",
        "edit_issue_list_type": "Punkteliste",
        "edit_responsible": "Verantwortlich",
        "edit_status": "Status"
      },
      "labels": {
        "activity": "Aktivität anzeigen",
        "addImagesSubtitle": "Ein Bild sagt mehr als tausend Worte",
        "addImagesTitle": "Fügen Sie Bilder hinzu, damit wir den Punkt noch besser verstehen können",
        "after_care_page_title": "Ihre Punkte",
        "all_categories_can_be_managed_under": "Alle Kategorien verwalten Sie unter den",
        "approvalNotRequested": "Genehmigung nicht angefordert",
        "approvalRequested": "Genehmigung angefordert",
        "approved": "Genehmigt",
        "approvedInfo": "Kunde hat diesen Punkt genehmigt",
        "assignee": "Zugewiesen an",
        "cancelCustomerApproval": "Anfrage zur Kundengenehmigung zurückziehen",
        "collapse": "Aktivität ausblenden",
        "company_settings": "Organisationseinstellungen",
        "count_edit": "Punkt bearbeiten | {count} Punkte bearbeiten",
        "create_new_category?": "Finden Sie die benötigte Kategorie nicht? Erstellen Sie eine neue!",
        "created_at": "Erstellt am",
        "customerApproved": "Vom Kunden genehmigt",
        "customerRejected": "Vom Kunden abgelehnt",
        "deadline_date": "Frist",
        "description": "Beschreibung",
        "descriptionSubtitle": "Verwenden Sie Aufzählungszeichen und kurze Sätze, damit wir den Punkt besser nachvollziehen können",
        "descriptionTitle": "Geben Sie eine kurze Beschreibung an",
        "edit_category": "Kategorie bearbeiten",
        "edit_issue": "Punkt bearbeiten",
        "isThisPointFixed": "Ist dies Ihrer Meinung nach behoben?",
        "issue_category_name": "Kategorie",
        "issue_status_name": "Status",
        "issues_clear_selection": "Auswahl aufheben",
        "issues_select_all_pages": "Alle {total} Punkte auswählen",
        "issues_select_one": "Wählen Sie mindestens 1 Punkt aus",
        "issues_selected": "Punkte ausgewählt",
        "issues_selected_all_pages": "Alle {total} Punkte ausgewählt",
        "issues_selected_count": "{selected} Punkt ausgewählt | {selected} Punkte ausgewählt",
        "name": "Name",
        "new": "Neuen Punkt erstellen",
        "new_category": "Neue Kategorie",
        "noDescriptionYet": "Noch keine Beschreibung",
        "no_issue_deadline": "Keine Frist festgelegt",
        "no_issues": "Keine Punkte",
        "no_responsible": "Kein Verantwortlicher",
        "origin": "Herkunft",
        "reason": "Grund",
        "redoRequest": "Anfrage wiederholen",
        "requestCustomerApproval": "Kundengenehmigung anfordern",
        "requested": "Angefordert",
        "requestedInfo": "Kundengenehmigung angefordert",
        "resetRequest": "Anfrage zurücksetzen",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Verantwortlich",
        "return_to_overview": "Zurück",
        "showIssuesfor": "Punkte anzeigen für",
        "statusExplained": "Was bedeutet jede Statusfarbe",
        "subjectSubtitle": "Nur 1 Meldung pro Punkt nötig. Um den Rest kümmern wir uns",
        "subjectTitle": "Beschreiben Sie den Punkt in wenigen Worten",
        "undoCustomerApproved": "Kundengenehmigung rückgängig machen",
        "unit_issues_will_be_shown_here": "Alle der Punkteliste zugeordneten Einheiten werden hier angezeigt",
        "unit_name": "Name der Einheit",
        "updated_at": "Letzte Aktualisierung",
        "waitingForApproval": "Dieser Punkt muss zunächst von {client_name} akzeptiert werden, bevor Sie eine Konversation starten können",
        "whyIsThisPointNotFixed": "Warum ist dieser Punkt nicht behoben?",
        "youApprovedThisPoint": "Laut Ihnen behoben",
        "youRejectedThisPoint": "Laut Ihnen nicht behoben"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Sie werden benachrichtigt, wenn ein neuer Punkt gemeldet wird.",
            "title": "Für Ihre Einheit wurden noch keine Punkte gemeldet"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Wenn Kunden neue Punkte erstellen, werden sie hier erneut angezeigt.",
            "title": "Sie haben alle eingehenden Punkte von Kunden bearbeitet"
          },
          "none": {
            "subtitle": "Beginnen Sie zu erfassen, was behoben oder verbessert werden soll",
            "title": "Erstellen Sie Ihren ersten Punkt"
          },
          "overview": {
            "subtitle": "Erstellen Sie Ihren ersten Punkt in einer Einheit, um zu beginnen",
            "title": "Punkte, die in allen Ihren Einheiten erstellt wurden, werden hier angezeigt"
          },
          "unit": {
            "title": "Alle Punkte für diese Einheit werden hier angezeigt"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Sobald Ihnen Punkte zugewiesen werden, sind sie hier sichtbar",
            "title": "Ihnen wurden noch keine Punkte zugewiesen"
          }
        }
      },
      "sortGroups": {
        "date": "Datum",
        "deadline": "Frist",
        "name": "Name"
      },
      "toasts": {
        "update": "Punkt aktualisiert"
      },
      "validation": {
        "issue_list_type_required": "Punkteliste ist erforderlich",
        "pleaseProvideAReason": "Bitte geben Sie einen Grund an",
        "status_required": "Status ist erforderlich"
      }
    }
  }
}
